import React from 'react';
import { MessageSquareQuote } from 'lucide-react';

/**
 * Mensaje libre que el negocio le deja a sus clientes en su página pública.
 *
 * Va arriba de todo, entre el encabezado y el paso 1, porque es lo que el
 * negocio quiere que se lea antes de elegir servicio ("estamos de vacaciones
 * hasta el 15", "traé tu toalla", "los martes 2x1").
 *
 * Dos reglas:
 * 1. Si no hay mensaje —o es todo espacios— no se renderiza NADA: ni el
 *    contenedor, ni un título, ni un espacio en blanco. Por eso el `return null`
 *    va antes de cualquier markup.
 * 2. Es texto que escribe el negocio, así que entra como texto: nunca como HTML.
 *    Los saltos de línea los respeta el CSS (`white-space: pre-line`), no un
 *    <br> armado a mano, que obligaría a interpretar el string.
 */
export default function MensajeNegocio({ mensaje }) {
  const texto = typeof mensaje === 'string' ? mensaje.trim() : '';
  if (!texto) return null;

  return (
    <section className="mx-auto max-w-5xl px-4 pt-8 sm:px-6 sm:pt-10">
      <div className="mensaje-negocio">
        <MessageSquareQuote className="mensaje-negocio-icono" aria-hidden="true" />
        <p className="mensaje-negocio-texto">{texto}</p>
      </div>
    </section>
  );
}
